var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 27.05,
    height: 35.052,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1256.38 1628.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil2,.fil7,.fil8{fill:#bdbfc1;fill-rule:nonzero}.fil2,.fil8{fill:#4b4b4d}.fil2{fill:#ed3237}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2044765681808"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.77 1427.63c140.21 204.84 768.36 307.77 907.73 36.06 30.21-79.5-74.64-259.14-368.87-310.29-294.11-51.17-601.21 114.16-538.86 274.24z",
    style: {
      fill: "#727376",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.27 1467.37c-7.07 9.08-14.68 17.45-22.86 25.44-150.41 143.82-491.7 89.63-676.83 16.5-77.21-30.44-127.15-64.2-124.87-88.39 136.52-164.15 689.61-247.19 824.56 46.45z",
    style: {
      fill: "#4f5f69",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M969.5 1463.68c.54-18.22-17.47-66.25-69.55-114.32-67.48-62.65-192.22-125.15-407.56-121.44-381.48 6.65-424.84 211.25-430.61 199.7-3.48-6.76-27.26-50.5-44.2-91.25l-4.46-10.8c-9.73-24.75-15.89-46.99-11.85-57.26 10.99-28.18 158.55-265 252.36-366.29-10.11-64.83 29.65-73.24 29.65-73.24s-39.57-654.42-12.32-684.15c0 0 6.69 2.9 19.13 8.11 110.1 46.85 667.23 284.28 875.78 391.05 50.94 26.17 81.19 44.41 78.89 50.1-12.59 31.9-319.46 370.95-319.46 370.95s24.08 44.61 4.23 77.78c-19.75 33.07-55.49 52.17-55.49 52.17s14.39 26.79 25.58 60.72c8.46 25.88 75.73 151.6 83.93 239.57 2.77 28.32-.77 52.66-14.04 68.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M666.06 707.5c-8.22-1.54-16.47-2.81-24.3-3.97 8.6.81 16.73 2.05 24.3 3.97z",
    style: {
      fill: "#7d2855",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83 151.78c.93-3.48 1.97-5.9 3.12-7.14-.75 1.62-1.39 3.34-1.88 5.14-3.97 14.83 2.23 33.67 17.13 55.26-1.32 122.53 34.02 533.33 49.4 534.57 16.64 1.25 98.2-66.16 304.4-36.14-89.67-6.34-229.17 50.15-294.37 120.9 135.64-46.55 358.46-14.97 421.31 105.29-119.49-75.2-216.62-97.57-336.4-61.74-56.28 16.99-103.45 55.03-116.05 102.1-12.34 46.03 8.43 100.71 86.25 152.8-174.67-.19-336.05 46.61-399.47 145.51 10.99-28.18 158.55-265 252.36-366.29-2.7-17.38-1.86-30.72.88-40.9 7.44-27.79 28.77-32.34 28.77-32.34s-36.23-599.42-15.45-677.01z",
    style: {
      fill: "#470411",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 1269.85c-.77 2.88-.93 6.5-.51 10.78-.42-4.28-.26-7.9.51-10.78z",
    style: {
      fill: "#8c2e41",
      fillRule: "nonzero"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M606.12 924.39c182.43 149.65 275.06 151.16 289.91 95.74.33-1.25.67-2.48.9-3.76 10.94-55.31-156.6-185.1-178.71-201.88 19.54 14.32 156.85 114.17 191.92 105.64 30.21-7.46 143.35-196.54 170.4-297.5.77-2.88 1.46-5.64 2.14-8.39 87.76 15.33 148.09 9.78 162.06-20.36.07-.32.09-.6.12-.91.05.25.02.51-.04.72-.02.11-.04.14-.09.19-12.59 31.9-319.46 370.95-319.46 370.95s18.13 33.6 9.94 64.2c-1.25 4.63-3.09 9.18-5.71 13.59-19.75 33.07-55.49 52.17-55.49 52.17s14.39 26.79 25.58 60.72c8.46 25.88 75.73 151.6 83.93 239.57 1.67 16.78 1.07 32.12-2.42 45.2-2.4 8.99-6.23 16.87-11.62 23.4 5.39-6.53 9.22-14.41 11.62-23.4 3.49-13.08 4.09-28.42 2.42-45.2-18.01-54.89-57.12-101.97-109.91-140.75l-59.49-160.47S616.95 953.93 606.1 924.39z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M899.9 1349.14c52.1 48.17 70.2 96.37 69.6 114.54.54-18.22-17.47-66.25-69.55-114.32l-.05-.23z",
    style: {
      fill: "#d15f6f",
      fillRule: "nonzero"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M969.5 1463.68c1.4-41.69-95.97-242.22-477.12-235.76-381.48 6.65-424.84 211.25-430.61 199.7-5.71-11.57-71.53-130.87-60.51-159.31 153.85-239.8 883.82-173.46 982.28 126.76 2.77 28.32-.77 52.66-14.04 68.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M109.72 1420.92c93.32-112.23 381.34-186.55 597.35-128.5 99.97 26.86 184.55 82.07 227.21 174.95-7.07 9.08-14.68 17.45-22.86 25.44-208.97-201.12-638.58-117.51-676.83 16.5-77.21-30.44-127.15-64.2-124.87-88.39z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "m1227.87 531.06-.26-.3c-16.04-37.64-37.16-75.52-37.16-75.52L1085.44 405c-73.43-50.56-167.47-103.78-273.43-152.65-85.89-39.64-168.89-71.52-243.32-94.44L409.61 81.85l-76.75 34.69-61.9 28.1c-29.93 64.51 163.82 217.38 432.77 341.49 268.97 124.13 511.17 172.3 541.03 107.77 1.76-13.43-6.37-38.02-16.89-62.83z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1219.36 404.12c-48.36-66.71-188.06-162.41-364.7-243.85C678.04 78.73 514.54 34.47 432.23 40.99l-34.35-15.83L379.2 65.5c-26.21 56.72 144.05 191.03 380.35 300.1 236.32 109 449.2 151.43 475.43 94.72l18.71-40.34-34.34-15.85z",
    style: {
      fill: "#627682",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.7 419.98c-26.33 56.68-239.11 14.27-475.43-94.72C541.93 216.25 371.6 81.9 397.88 25.16c26.33-56.7 239.11-14.29 475.41 94.76 236.35 109.01 406.67 243.36 380.41 300.06z",
    style: {
      fill: "#6f8694",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.76 392.36c-2.55 5.56-7.67 10.01-14.85 13.06-52.42 23.56-220.92-18.27-406.65-103.92-185.8-85.72-326.85-186.75-342.86-241.87-2.28-7.43-2.25-14.17.37-19.78 21.86-47.03 210.5-6.27 421.45 91.06 211.02 97.36 364.36 214.36 342.54 261.46z",
    style: {
      fill: "#495861",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.91 405.42c-52.42 23.56-220.92-18.27-406.65-103.92-185.8-85.72-326.85-186.75-342.86-241.87 52.61-23.22 220.94 18.61 406.56 104.27 185.66 85.63 326.57 186.46 342.95 241.52z",
    style: {
      fill: "#5e717d",
      fillRule: "nonzero"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "m889.67 316.61.02-.05c3.25-11.87 12.92-45.48 103.91-45.47 53-.04 120.48 65.5 112.35 95.83-1.47 5.53-5.49 9.94-12.52 12.48-45.8 16.69-206.92-50.96-203.76-62.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTin);
export default __webpack_public_path__ + "static/media/tin.e09d35409b42cf3acbbdb32fc7065681.svg";
export { ForwardRef as ReactComponent };